import { ref } from "vue";

const title = ref("");
const subtitle = ref("");
const showMore = ref(false);
const showShare = ref(false);

export function useTopBar() {
  function set(opts = {}) {
    title.value = opts.title ?? "";
    subtitle.value = opts.subtitle ?? "";
    showMore.value = !!opts.showMore;
    showShare.value = !!opts.showShare;
  }
  return { title, subtitle, showMore, showShare, set };
}
